import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { MenuListSwitch } from "./MenuListSwitch";
import {Link, useRouteMatch} from "react-router-dom";
import Button from "../../components/Button/Button";
import { AiFillEdit } from "react-icons/ai";
import { useUpdateMenuStatus } from "../../network";

export const MenuList = ({
    uploadedData,
    alert,
    setAlert,
}) => {
    const { t } = useTranslation();
    const { url } = useRouteMatch()

    useEffect(() => {
        setTimeout(() => setAlert(false), 10000);
    }, [alert]);

    const isPosActive = uploadedData.some(menu => menu.type === 'pos' && menu.status === 'active')

    return (
        <div className="grid grid-cols-1 max-w-7xl mb-6">
            <div
                className="py-3 text-gray-500 text-sm"
                style={{ display: alert ? "flex" : "none" }}
            >
                <img
                    src="/menuicon/POS_info.svg"
                    alt="info"
                    width={20}
                    height={20}
                    className="mr-1.5"
                />
                {t(
                    "POS import successful! You can now view and manage your menus below"
                )}
            </div>

            <div className="rounded-lg shadow-md bg-white px-5">
                <table
                    className="min-w-full"
                    style={{ borderSpacing: "0 12px" }}
                >
                    <thead>
                        <tr>
                            <th
                                scope="col"
                                className="py-3 text-sm font-bold text-left"
                            >
                                {t("Name")}
                            </th>
                            <th
                                scope="col"
                                className="px-6 py-3 text-sm font-bold"
                            >
                                {t("Status")}
                            </th>
                            <th
                                scope="col"
                                className="px-6 py-3 text-sm font-bold"
                            >
                                {t("Type")}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {uploadedData?.map((item) => (
                            <tr
                                key={item.id}
                                className="rounded-lg bg-white px-5 py-4 border-b"
                            >
                                <td className="w-1/2 px-4 py-4 whitespace-nowrap">
                                    <div className="flex items-center justify-start">
                                        <Link
                                            to={`${url}/${item.id}/edit`}
                                            className="inline-flex items-center text-indigo-600 hover:text-indigo-900 mr-3"
                                        >
                                            <AiFillEdit size={20} />
                                        </Link>
                                        <span>{item.name}</span>
                                    </div>
                                </td>
                                <td className=" px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center justify-center">
                                        <MenuListSwitch
                                            item={item}
                                            isDisabled={isPosActive}
                                        />
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center justify-center">
                                        {item.type}
                                    </div>
                                </td>
                                <td className="w-10 px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center justify-end">
                                        <div className="text-sm font-medium">
                                            {item.status !== "archived"? (
                                                <Link
                                                    to={`${url}/${item.id}/items`}
                                                    className="text-purple-500 text-sm font-medium"
                                                >
                                                    {t("View Menu")}
                                                </Link>
                                            ): (
                                                <span>{t("View Menu")}</span>
                                            )}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
